"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"];
//# sourceMappingURL=ring.js.map